import { cardPageController } from 'magner';
import { baseT } from 'configs/translation/base';
import { adminsT } from './index';
import {
  get, create, update, 
} from './requests';
import type { Edit } from './types';
import { userRoles } from '~/utils/searchInit';
import AdminStatusCard from './components/admin-status-card.vue';

export const cardConfig = cardPageController<Edit>({
  header: {
    title: adminsT('card.title'),
  },

  getRequest: get,
  updateRequest: update,
  createRequest: create,

  form: {
    actions: [
      {
        type: 'link',
        to: () => ({ name: 'admins' }),
        props: {
          text: baseT('form.back_button'),
          class: 'width-auto',
        },
      },
      {
        type: 'link',
        to: (route): any => ({ name: 'admins-edit', params: { route } }),
        props: {
          text: baseT('form.edit_button'),
          class: 'width-auto',
          type: 'primary',
        },
      },
    ],

    layout: {
      type: 'column',
      props: {},
      layout: [
        /** Left column */
        {
          type: 'column',
          props: {
            span: 12,
            xs: 24,
            styles: { 'padding-right': '12px' },
          },
          layout: [
            {
              type: 'column',
              props: {},
              fields: [
                {
                  type: 'input',
                  name: 'name',
                  label: baseT('label.userName'),
                  dataType: 'string',
                  props: {
                    readOnly: true,
                  },
                },
                {
                  type: 'input',
                  name: 'surname',
                  label: baseT('label.surname'),
                  dataType: 'string',
                  props: {
                    readOnly: true,
                  },
                },
              ],
            },
            {
              type: 'row',
              props: {
                justify: 'space-between',
                elementsGrow: true,
                styles: { gap: '12px', flexWrap: 'nowrap' },
              },
              fields: [
                {
                  type: 'select',
                  name: 'roles',
                  options: [],
                  label: baseT('label.role'),
                  dataType: 'string',
                  props: {
                    multiple: true,
                    remote: true,
                    remoteMethod: userRoles,
                    disabled: true,
                  },
                },
                {
                  type: 'select',
                  name: 'status',
                  label: baseT('label.status'),
                  dataType: 'string',
                  options: [],
                  props: {
                    readOnly: true,
                    readOnlyFormatter: (val) => val?.label,
                  },
                },
              ],
            },

            {
              type: 'row',
              props: {
                justify: 'space-between',
                elementsGrow: true,
                styles: { gap: '12px', flexWrap: 'nowrap' },
              },
              fields: [
                {
                  type: 'input',
                  name: 'phone',
                  label: baseT('label.phone'),
                  dataType: 'string',
                  props: {
                    mask: {
                      mask: '+7 (###) ###-##-##',
                    },
                    readOnly: true,
                  },
                },
                {
                  type: 'input',
                  name: 'email',
                  label: baseT('label.email'),
                  dataType: 'string',
                  props: {
                    readOnly: true,
                  },
                },
              ],
            },
          ],
        },

        /** Right column */
        {
          type: 'column',
          props: {},
          layout: [
          ],
        },
      ],
    },
  },
});
